import React, { useState, useEffect } from 'react';
import logo from '../BitsImages/logoooo12345.jpg';
import { Link } from 'react-router-dom';

const ContactForm = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('[data-animate]');
    animatedElements.forEach(element => {
      observer.observe(element);
    });

    return () => {
      animatedElements.forEach(element => {
        observer.unobserve(element);
      });
    };
  }, []);
  // State hooks for form values and validation errors
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
    agreePrivacy: false
  });

  const [errors, setErrors] = useState({
    fullName: '',
    email: '',
    phone: '',
    message: '',
    agreePrivacy: ''
  });

  const [result, setResult] = useState("");

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  // Handle form submission with Web3Forms
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Basic validation
    if (!formData.fullName) newErrors.fullName = 'Full name is required';
    if (!formData.email) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
    if (!formData.phone) newErrors.phone = 'Phone number is required';
    else if (!/^[6789]\d{9}$/.test(formData.phone)) newErrors.phone = 'Phone number must start with 6, 7, 8, or 9 and be 10 digits';
    if (!formData.message) newErrors.message = 'Message is required';
    if (!formData.agreePrivacy) newErrors.agreePrivacy = 'You must agree to the privacy policy';

    // If no errors, submit the form via Web3Forms
    if (Object.keys(newErrors).length === 0) {
      try {
        setResult("Sending....");
        const web3FormData = new FormData();
        web3FormData.append("access_key", "017080b9-1d21-4076-b2b8-4ea5040869d9");
        web3FormData.append("name", formData.fullName);
        web3FormData.append("email", formData.email);
        web3FormData.append("phone", formData.phone);
        web3FormData.append("message", formData.message);

        const response = await fetch("https://api.web3forms.com/submit", {
          method: "POST",
          body: web3FormData
        });

        const data = await response.json();

        if (data.success) {
          setResult("Form Submitted Successfully");
          setFormData({
            fullName: '',
            email: '',
            phone: '',
            message: '',
            agreePrivacy: false
          });
        } else {
          setResult(data.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setResult("An error occurred. Please try again.");
      }
    }

    setErrors(newErrors);
  };

  // Handle WhatsApp click
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hello, how may I help you?');
    const phone = '+919035299266'; // assuming you want to send the phone number
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  const isSending = result === 'Sending....';
  const isSuccess = result === 'Form Submitted Successfully';
  const isFailure = result && !isSending && !isSuccess;

  return (
    <section className="cf2-section">
      <style>{`
        .cf2-section {
          position: relative;
          background: #FBF8F2;
          padding: 5.5rem 2rem;
          overflow: hidden;
        }

        .cf2-glow {
          position: absolute;
          border-radius: 50%;
          filter: blur(90px);
          pointer-events: none;
          opacity: 0.45;
        }

        .cf2-glow-1 {
          width: 420px;
          height: 420px;
          top: -10%;
          right: -8%;
          background: radial-gradient(circle, rgba(184,134,11,0.14) 0%, transparent 70%);
        }

        .cf2-glow-2 {
          width: 360px;
          height: 360px;
          bottom: -14%;
          left: -8%;
          background: radial-gradient(circle, rgba(139,124,246,0.12) 0%, transparent 70%);
        }

        .cf2-wrap {
          position: relative;
          z-index: 2;
          max-width: 1180px;
          margin: 0 auto;
        }

        .cf2-kicker {
          display: inline-flex;
          align-items: center;
          gap: 0.55rem;
          padding: 0.38rem 0.9rem 0.38rem 0.65rem;
          background: #FFFFFF;
          border: 1px solid rgba(184,134,11,0.25);
          border-radius: 999px;
          font-size: 0.7rem;
          font-weight: 700;
          letter-spacing: 1.2px;
          text-transform: uppercase;
          color: #9A6B0C;
          margin-bottom: 1rem;
          opacity: 0;
          transform: translateY(10px);
          transition: opacity 0.6s ease, transform 0.6s ease;
        }

        .cf2-kicker.in-view {
          opacity: 1;
          transform: translateY(0);
        }

        .cf2-kicker-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #B8860B;
        }

        .cf2-heading {
          font-family: Georgia, 'Times New Roman', serif;
          font-size: clamp(1.9rem, 3.4vw, 2.7rem);
          font-weight: 600;
          color: #18160F;
          letter-spacing: -0.015em;
          margin-bottom: 0.6rem;
          opacity: 0;
          transform: translateY(14px);
          transition: opacity 0.7s ease, transform 0.7s ease;
        }

        .cf2-heading.in-view {
          opacity: 1;
          transform: translateY(0);
        }

        .cf2-lead {
          font-size: 0.96rem;
          color: #5C5848;
          max-width: 480px;
          line-height: 1.6;
          margin-bottom: 2.4rem;
        }

        .cf2-grid {
          display: grid;
          grid-template-columns: 1.1fr 0.85fr;
          gap: 1.5rem;
          align-items: stretch;
        }

        .cf2-panel {
          background: #FFFFFF;
          border: 1px solid rgba(24,22,18,0.08);
          border-radius: 1.25rem;
          padding: 2rem;
          box-shadow: 0 20px 50px rgba(24,22,18,0.06);
          opacity: 0;
          transform: translateX(-24px);
          transition: opacity 0.7s ease, transform 0.7s ease;
        }

        .cf2-panel.in-view {
          opacity: 1;
          transform: translateX(0);
        }

        .cf2-form-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #18160F;
          margin-bottom: 1.5rem;
          letter-spacing: -0.01em;
        }

        .cf2-field {
          margin-bottom: 1.1rem;
        }

        .cf2-label {
          display: block;
          font-size: 0.78rem;
          font-weight: 700;
          color: #4B4534;
          margin-bottom: 0.4rem;
          letter-spacing: 0.2px;
        }

        .cf2-input,
        .cf2-textarea {
          width: 100%;
          padding: 0.75rem 0.95rem;
          background: #FAF8F2;
          border: 1px solid rgba(24,22,18,0.12);
          border-radius: 0.65rem;
          font-size: 0.88rem;
          color: #18160F;
          font-family: inherit;
          transition: border-color 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
        }

        .cf2-input::placeholder,
        .cf2-textarea::placeholder {
          color: #A8A294;
        }

        .cf2-input:focus,
        .cf2-textarea:focus {
          outline: none;
          border-color: #B8860B;
          background: #FFFFFF;
          box-shadow: 0 0 0 3px rgba(184,134,11,0.12);
        }

        .cf2-error {
          font-size: 0.75rem;
          color: #C0392B;
          margin-top: 0.35rem;
          font-weight: 600;
        }

        .cf2-connect-row {
          display: flex;
          align-items: center;
          gap: 0.9rem;
          margin: 0.3rem 0 1.3rem;
          flex-wrap: wrap;
        }

        .cf2-connect-link {
          text-decoration: none;
        }

        .cf2-connect-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.6rem 1rem;
          background: #FAF8F2;
          border: 1px solid rgba(24,22,18,0.12);
          border-radius: 0.6rem;
          color: #18160F;
          font-size: 0.8rem;
          font-weight: 600;
          cursor: pointer;
          transition: border-color 0.22s ease, transform 0.22s ease, background 0.22s ease;
        }

        .cf2-connect-btn:hover {
          border-color: #B8860B;
          background: #FFF8E8;
          transform: translateY(-1px);
        }

        .cf2-connect-or {
          font-size: 0.78rem;
          font-weight: 700;
          color: #A8A294;
        }

        .cf2-checkbox-row {
          display: flex;
          align-items: flex-start;
          gap: 0.6rem;
          margin-bottom: 1.4rem;
        }

        .cf2-checkbox-row input {
          margin-top: 0.2rem;
          accent-color: #B8860B;
          width: 16px;
          height: 16px;
          flex-shrink: 0;
        }

        .cf2-checkbox-label {
          font-size: 0.8rem;
          color: #5C5848;
          line-height: 1.5;
        }

        .cf2-submit {
          width: 100%;
          padding: 0.85rem 1.5rem;
          background: #18160F;
          color: #FBF8F2;
          font-size: 0.9rem;
          font-weight: 700;
          border: none;
          border-radius: 0.65rem;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.55rem;
          transition: background 0.22s ease, transform 0.22s ease;
        }

        .cf2-submit:hover {
          background: #322E1E;
          transform: translateY(-1px);
        }

        .cf2-submit:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .cf2-spinner {
          width: 14px;
          height: 14px;
          border: 2px solid rgba(251,248,242,0.35);
          border-top-color: #FBF8F2;
          border-radius: 50%;
          animation: cf2Spin 0.7s linear infinite;
        }

        @keyframes cf2Spin {
          to { transform: rotate(360deg); }
        }

        .cf2-status {
          margin-top: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          padding: 0.6rem 1rem;
          border-radius: 0.6rem;
          font-size: 0.82rem;
          font-weight: 700;
          opacity: 0;
          transform: translateY(6px);
          animation: cf2StatusIn 0.4s ease forwards;
        }

        @keyframes cf2StatusIn {
          to { opacity: 1; transform: translateY(0); }
        }

        .cf2-status.success {
          background: #E3F3EA;
          color: #1B7A43;
        }

        .cf2-status.sending {
          background: #FBEFD8;
          color: #9A6B0C;
        }

        .cf2-status.failure {
          background: #FBE5E2;
          color: #C0392B;
        }

        .cf2-side-panel {
          background: #FAF6EB;
          border: 1px solid rgba(184,134,11,0.18);
          border-radius: 1.25rem;
          padding: 2rem;
          box-shadow: 0 20px 50px rgba(24,22,18,0.06);
          opacity: 0;
          transform: translateX(24px);
          transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
          display: flex;
          flex-direction: column;
        }

        .cf2-side-panel.in-view {
          opacity: 1;
          transform: translateX(0);
        }

        .cf2-profile {
          display: flex;
          align-items: center;
          gap: 0.9rem;
          margin-bottom: 1.6rem;
          padding-bottom: 1.6rem;
          border-bottom: 1px solid rgba(24,22,18,0.08);
        }

        .cf2-profile-img {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #FFFFFF;
          box-shadow: 0 4px 14px rgba(24,22,18,0.12);
          flex-shrink: 0;
        }

        .cf2-meeting-title {
          font-size: 0.92rem;
          font-weight: 700;
          color: #18160F;
          line-height: 1.4;
        }

        .cf2-contact-list {
          display: flex;
          flex-direction: column;
          gap: 0.85rem;
          margin-bottom: 1.6rem;
        }

        .cf2-contact-item {
          display: flex;
          align-items: flex-start;
          gap: 0.7rem;
        }

        .cf2-contact-icon {
          width: 32px;
          height: 32px;
          border-radius: 0.55rem;
          background: #FFFFFF;
          border: 1px solid rgba(184,134,11,0.22);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #B8860B;
          font-size: 0.85rem;
          flex-shrink: 0;
        }

        .cf2-contact-item a {
          font-size: 0.83rem;
          color: #5C5848;
          text-decoration: none;
          line-height: 1.5;
          transition: color 0.2s ease;
        }

        .cf2-contact-item a:hover {
          color: #B8860B;
        }

        .cf2-follow-label {
          font-size: 0.78rem;
          font-weight: 700;
          color: #4B4534;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          margin-bottom: 0.7rem;
        }

        .cf2-social-row {
          display: flex;
          gap: 0.6rem;
          margin-bottom: 1.6rem;
        }

        .cf2-social-icon {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background: #FFFFFF;
          border: 1px solid rgba(24,22,18,0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #18160F;
          font-size: 0.9rem;
          transition: all 0.22s ease;
        }

        .cf2-social-icon:hover {
          background: #B8860B;
          border-color: #B8860B;
          color: #FFFFFF;
          transform: translateY(-3px);
        }

        .cf2-quote {
          margin-top: auto;
          font-size: 0.88rem;
          font-style: italic;
          color: #18160F;
          line-height: 1.6;
          padding-top: 1.4rem;
          border-top: 1px solid rgba(24,22,18,0.08);
        }

        @media (max-width: 980px) {
          .cf2-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 600px) {
          .cf2-section {
            padding: 4rem 1.1rem;
          }

          .cf2-panel, .cf2-side-panel {
            padding: 1.4rem;
            border-radius: 1rem;
          }

          .cf2-connect-row {
            flex-direction: column;
            align-items: stretch;
          }

          .cf2-connect-btn {
            justify-content: center;
            width: 100%;
          }

          .cf2-connect-or {
            text-align: center;
          }

          .cf2-profile {
            flex-direction: column;
            text-align: center;
          }
        }

        @media (prefers-reduced-motion: reduce) {
          .cf2-kicker, .cf2-heading, .cf2-panel, .cf2-side-panel {
            opacity: 1 !important;
            transform: none !important;
            transition: none !important;
          }
        }
      `}</style>

      <div className="cf2-glow cf2-glow-1"></div>
      <div className="cf2-glow cf2-glow-2"></div>

      <div className="cf2-wrap">
        <span className="cf2-kicker" data-animate="slideUp">
          <span className="cf2-kicker-dot"></span>
          Get In Touch
        </span>
        <h2 className="cf2-heading" data-animate="slideUp">Drop a message to us</h2>
        <p className="cf2-lead">
          Tell us what you're building. We typically respond within one business day with
          next steps tailored to your project.
        </p>

        <div className="cf2-grid">
          <div className="cf2-panel" data-animate="slideInLeft">
            <h3 className="cf2-form-title">Send a message</h3>
            <form id="contactForm" onSubmit={handleSubmit}>
              <div className="cf2-field">
                <label className="cf2-label">Full name *</label>
                <input
                  className="cf2-input"
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  placeholder="We are sincerely pleased to know your full name"
                  required
                />
                {errors.fullName && <div className="cf2-error">{errors.fullName}</div>}
              </div>

              <div className="cf2-field">
                <label className="cf2-label">Email address *</label>
                <input
                  className="cf2-input"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="We build a relationship, not interrupt your workflow"
                  required
                />
                {errors.email && <div className="cf2-error">{errors.email}</div>}
              </div>

              <div className="cf2-field">
                <label className="cf2-label">Phone *</label>
                <input
                  className="cf2-input"
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  placeholder="Your phone number"
                  required
                />
                {errors.phone && <div className="cf2-error">{errors.phone}</div>}
              </div>

              <div className="cf2-connect-row">
                <Link
                  className="cf2-connect-link"
                  to="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z/data=!3m1!4b1!4m4!3m3!8m2!3d15.1618988!4d76.9384711?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button type="button" className="cf2-connect-btn">
                    <i className="bi bi-geo-alt-fill"></i> Reach Us via Google Maps
                  </button>
                </Link>
                <span className="cf2-connect-or">OR</span>
                <button type="button" className="cf2-connect-btn" onClick={handleWhatsAppClick}>
                  <i className="bi bi-whatsapp"></i> Connect via WhatsApp
                </button>
              </div>

              <div className="cf2-field">
                <label className="cf2-label">Message</label>
                <textarea
                  className="cf2-textarea"
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  placeholder="Need a requirement solved, let's us help."
                  style={{ resize: 'none' }}
                ></textarea>
                {errors.message && <div className="cf2-error">{errors.message}</div>}
              </div>

              <div className="cf2-checkbox-row">
                <input
                  type="checkbox"
                  id="privacy"
                  name="agreePrivacy"
                  checked={formData.agreePrivacy}
                  onChange={handleInputChange}
                  required
                />
                <label htmlFor="privacy" className="cf2-checkbox-label">
                  I agree to provide information in accordance with Bellary Info Tech Solutions privacy policies.
                </label>
              </div>
              {errors.agreePrivacy && <div className="cf2-error" style={{ marginTop: '-0.9rem', marginBottom: '1rem' }}>{errors.agreePrivacy}</div>}

              <button type="submit" className="cf2-submit" disabled={isSending}>
                {isSending && <span className="cf2-spinner"></span>}
                {isSending ? 'Sending' : 'Submit'}
              </button>
            </form>

            {result && (
              <div className={`cf2-status ${isSuccess ? 'success' : isSending ? 'sending' : 'failure'}`}>
                <i className={`bi ${isSuccess ? 'bi-check-circle-fill' : isSending ? 'bi-hourglass-split' : 'bi-exclamation-circle-fill'}`}></i>
                {result}
              </div>
            )}
          </div>

          <div className="cf2-side-panel" data-animate="slideInRight">
            <div className="cf2-profile">
              <img src={logo} alt="Profile" className="cf2-profile-img" />
              <h4 className="cf2-meeting-title">Bellary Info Tech Solutions — Meeting &amp; Greeting</h4>
            </div>

            <div className="cf2-contact-list">
              <div className="cf2-contact-item">
                <span className="cf2-contact-icon"><i className="bi bi-geo-alt-fill"></i></span>
                <a href="https://www.google.com/maps/place/15%C2%B009'42.8%22N+76%C2%B056'18.5%22E/@15.1618988,76.9358962,17z" target="_blank" rel="noopener noreferrer">
                  Plot No 7, Ward No 18/21, Kappagal Road, M V Nagar 9th Cross, Bellary 583103
                </a>
              </div>
              <div className="cf2-contact-item">
                <span className="cf2-contact-icon"><i className="bi bi-telephone-fill"></i></span>
                <a href="tel:+919603299266">+91 9603299266</a>
              </div>
              <div className="cf2-contact-item">
                <span className="cf2-contact-icon"><i className="bi bi-telephone-fill"></i></span>
                <a href="tel:+919703299266">+91 9703299266</a>
              </div>
              <div className="cf2-contact-item">
                <span className="cf2-contact-icon"><i className="bi bi-envelope-fill"></i></span>
                <a href="mailto:info@bellaryinfotech.com">info@bellaryinfotech.com</a>
              </div>
            </div>

            <div className="cf2-follow-label">Follow Us</div>
            <div className="cf2-social-row">
              <Link className="cf2-social-icon" to="https://www.facebook.com/BellaryInfotech" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-facebook"></i>
              </Link>
              <Link className="cf2-social-icon" to="https://x.com/home?lang=en-in" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-twitter"></i>
              </Link>
              <Link className="cf2-social-icon" to="https://www.linkedin.com/company/bellary-infotech-solutions" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-linkedin"></i>
              </Link>
              <Link className="cf2-social-icon" to="https://www.instagram.com/bellary_info_tech25?igsh=bm4wbm9ya3kydGQz" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-instagram"></i>
              </Link>
            </div>

            <div className="cf2-quote">"Empowering your IT solutions for a better tomorrow."</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;